import React from "react";
import {useGetAllApplications} from "../../hooks/applications.hooks";
import { Select } from "antd";


const ApplicationSelect = (props) =>{
  const {appChange,applicationId} = props;

  const {
    isLoading: isLoadingApplicationsData,
    data: applicationsData,
    refetch: reloadGetApplication,
  } = useGetAllApplications();

  return (
      <Select
        allowClear={true} 
        placeholder="Enter Solution"
        showSearch
        optionFilterProp="children"
        onChange={appChange}
        style={{ width: '100%' }}
        value={applicationId}
      >
        {!isLoadingApplicationsData && applicationsData?.map((e) => (
          <Select.Option key={e._id}>{e.app_name}</Select.Option>
        ))}
      </Select>
  );
}

export default ApplicationSelect;